module.exports = "https://www.gc-pro.gnp.com.mx/8d8ddedfb8f8324878d0daf7e6d38c42.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/vector-ok.png
// module id = 8171
// module chunks = 0